import axios from 'axios';
import useSWR from 'swr';

import { getApiUrl } from '@/helpers/api';

export const useCoach = (id) => {
  const urlStr = id ? `${getApiUrl()}/coach/${id}` : null;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        throw Error(err);
      }
    },
    {
      dedupingInterval: 30000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const useCoachSelf = () => {
  const urlStr = `${getApiUrl()}/coach/self`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        throw Error(err);
      }
    },
    {
      dedupingInterval: 30000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const usePutCoachSelf = () => {
  const putCoach = async (payload) => {
    try {
      const url = `${getApiUrl()}/coach/self`;
      const response = await axios.put(url, payload);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return putCoach;
};

export const useCoaches = (query) => {
  let queryStr = '';
  if (query && Object.keys(query).length) {
    // Filter out null values from the query object
    const filteredQuery = Object.fromEntries(
      // eslint-disable-next-line no-unused-vars
      Object.entries(query).filter(([_, value]) => value != null)
    );
    const params = new URLSearchParams(filteredQuery);
    queryStr = `?${params.toString()}`;
  }
  const urlStr = `${getApiUrl()}/coach${queryStr}`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        throw Error(err);
      }
    },
    {
      dedupingInterval: 30000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const usePostCoach = () => {
  const postCoach = async (payload) => {
    try {
      const url = `${getApiUrl()}/coach`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return postCoach;
};

export const usePostCoachProfileImage = () => {
  const postCoachProfileImage = async (payload) => {
    try {
      const url = `${getApiUrl()}/coach/profile-image`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return postCoachProfileImage;
};

export const useDeleteCoachProfileImage = () => {
  const deleteCoachProfileImage = async (id) => {
    try {
      const url = `${getApiUrl()}/coach-profile-image/${id}`;
      const response = await axios.delete(url);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return deleteCoachProfileImage;
};
